import { render, staticRenderFns } from "./CustomerActUpdateDeleteBtn.vue?vue&type=template&id=a088335c&"
import script from "./CustomerActUpdateDeleteBtn.vue?vue&type=script&lang=js&"
export * from "./CustomerActUpdateDeleteBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports